import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

import Tag from "./components/Tag"

const StatusTags = ({ className, children, titleIsHidden }) => {
  return (
    <div className={`status-tags ${className}`}>
      {!titleIsHidden && <div className="status-tags_title">Plan Status:</div>}

      <ul>{children}</ul>
    </div>
  )
}

StatusTags.defaultProps = {
  titleIsHidden: true,
  className: ""
}

StatusTags.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  titleIsHidden: propTypes.bool,
  className: propTypes.string
}

export { Tag }

export default StatusTags
